import { mapMailTemplateVariables } from '../actionHelper';
export default {
  methods: {
    openSettingsModal(file, i) {
      this.editForm = JSON.parse(JSON.stringify({ ...file }));
      if (!this.editForm.permission_settings) {
        this.editForm = JSON.parse(
          JSON.stringify({
            ...this.editForm,
            ...{
              permission_settings: {
                type: 'DAY',
                value: 1,
                application_users: [],
                lock_folder: false,
              },
            },
          })
        );
      }
      if (!this.editForm.approval_settings) {
        this.editForm = JSON.parse(
          JSON.stringify({
            ...this.editForm,
            ...{
              approval_settings: {
                approval_folder: false,
                requesting_users: [],
                approver_type: 'APPLICATION_USER',
                approver_user_ids: [],
                approver_users: [],
                mail_template_data: {
                  subject: 'Approval request',
                  body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
                  cc_user: [],
                  header_body: '',
                  footer_body: '',
                  name: '',
                },
              },
            },
          })
        );
      } else {
        if (!this.editForm?.approval_settings?.mail_template_data) {
          this.editForm['approval_settings'] = JSON.parse(
            JSON.stringify({
              ...this.editForm['approval_settings'],
              mail_template_data: {
                subject: 'Approval request',
                body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
                cc_user: [],
                header_body: '',
                footer_body: '',
                name: '',
              },
            })
          );
        } else {
          if (this.editForm?.approval_settings?.mail_template_data?.body) {
            this.editForm.approval_settings.mail_template_data.body = mapMailTemplateVariables(
              this.editForm.approval_settings.mail_template_data.body,
              true
            );
          }
          if (this.editForm?.approval_settings?.mail_template_data?.subject) {
            this.editForm.approval_settings.mail_template_data.subject = mapMailTemplateVariables(
              this.editForm.approval_settings.mail_template_data.subject,
              true
            );
          }
        }
      }
      if (!this.editForm.approval_notify_settings) {
        this.editForm = JSON.parse(
          JSON.stringify({
            ...this.editForm,
            ...{
              approval_notify_settings: {
                notify_user_type: 'APPLICATION_USER',
                notify_user_ids: [],
                notify_users: [],
                notify_user_fields: [],
                mail_template_data: {
                  subject: 'Files has approved',
                  body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
                  cc_user: [],
                  header_body: '',
                  footer_body: '',
                  name: '',
                },
              },
            },
          })
        );
      } else {
        if (this.editForm?.approval_notify_settings?.mail_template_data?.body) {
          this.editForm.approval_notify_settings.mail_template_data.body = mapMailTemplateVariables(
            this.editForm.approval_notify_settings.mail_template_data.body,
            true
          );
        }
        if (this.editForm?.approval_notify_settings?.mail_template_data?.subject) {
          this.editForm.approval_notify_settings.mail_template_data.subject =
            mapMailTemplateVariables(
              this.editForm.approval_notify_settings.mail_template_data.subject,
              true
            );
        }
      }

      if (!this.editForm.decline_notify_settings) {
        this.editForm = JSON.parse(
          JSON.stringify({
            ...this.editForm,
            ...{
              decline_notify_settings: {
                notify_user_type: 'APPLICATION_USER',
                notify_user_ids: [],
                notify_users: [],
                notify_user_fields: [],
                mail_template_data: {
                  subject: 'Files has declined',
                  body: '<p>Hello,</p>\n\n<p>We are regret to inform you that your File has been rejected.</p>\n\n<p>Thank you.</p>\n',
                  cc_user: [],
                  header_body: '',
                  footer_body: '',
                  name: '',
                },
              },
            },
          })
        );
      } else {
        if (this.editForm?.decline_notify_settings?.mail_template_data?.body) {
          this.editForm.decline_notify_settings.mail_template_data.body = mapMailTemplateVariables(
            this.editForm.decline_notify_settings.mail_template_data.body,
            true
          );
        }
        if (this.editForm?.decline_notify_settings?.mail_template_data?.subject) {
          this.editForm.decline_notify_settings.mail_template_data.subject =
            mapMailTemplateVariables(
              this.editForm.decline_notify_settings.mail_template_data.subject,
              true
            );
        }
      }
      if (!this.editForm.upload_filter) {
        this.editForm['upload_filter'] = '';
      }

      this.editFormIndex = i;
      this.settingsModal = true;
    },
    update() {
      if (this.editForm?.approval_notify_settings?.mail_template_data?.body) {
        this.editForm.approval_notify_settings.mail_template_data.body = mapMailTemplateVariables(
          this.editForm.approval_notify_settings.mail_template_data.body
        );
      }
      if (this.editForm?.approval_notify_settings?.mail_template_data?.subject) {
        this.editForm.approval_notify_settings.mail_template_data.subject =
          mapMailTemplateVariables(
            this.editForm.approval_notify_settings.mail_template_data.subject
          );
      }
      if (this.editForm?.decline_notify_settings?.mail_template_data?.body) {
        this.editForm.decline_notify_settings.mail_template_data.body = mapMailTemplateVariables(
          this.editForm.decline_notify_settings.mail_template_data.body
        );
      }
      if (this.editForm?.decline_notify_settings?.mail_template_data?.subject) {
        this.editForm.decline_notify_settings.mail_template_data.subject = mapMailTemplateVariables(
          this.editForm.decline_notify_settings.mail_template_data.subject
        );
      }
      if (this.editForm?.approval_settings?.mail_template_data?.body) {
        this.editForm.approval_settings.mail_template_data.body = mapMailTemplateVariables(
          this.editForm.approval_settings.mail_template_data.body
        );
      }
      if (this.editForm?.approval_settings?.mail_template_data?.subject) {
        this.editForm.approval_settings.mail_template_data.subject = mapMailTemplateVariables(
          this.editForm.approval_settings.mail_template_data.subject
        );
      }
      this.actionEntityFoldersList[this.editFormIndex] = JSON.parse(
        JSON.stringify({ ...this.editForm })
      );
      this.resetEditModal();
    },
  },
};
